module.exports = __webpack_public_path__ + "static/media/01_LOGO.c0bfe979.png";